import React from "react";
import { Dropdown, Form, Grid } from "semantic-ui-react";

const AddVisitor = (props) => {
  const handleVisitorAdd = (newVisitors) => {
    const idOfVisitors = newVisitors.map((visitor) => {
      let id;
      props.visitorOptions.forEach((person) => {
        if (person.value === visitor) id = person.key;
      });
      return id;
    });
    const attenders = [...props.visitors, ...idOfVisitors];
    props.getVisitors(attenders.filter((a) => a));
  };

  return (
    <div className="addEventBody">
      <Grid divided="vertically">
        <Grid.Row stackable="true" columns={1}>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Form.Field required>
              <label>Add New Attendants</label>
              <Dropdown
                placeholder="Select Attendants"
                fluid
                search
                multiple
                selection
                options={props.visitorOptions}
                onChange={(e, data) => {
                  handleVisitorAdd(data.value);
                }}
              />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default AddVisitor;
